<template>
  <div>
    <b-sidebar
      id="sidebar-customer"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-customer-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div class="py-3" v-else>
          <label class="ml-2">ค้นหาข้อมูลลูกค้า</label>
          <div class="mx-2 mt-2 d-flex">
            <b-input-group class="panel-input-border">
              <b-form-input
                id="product-search"
                class="input-serach rounded-circle"
                placeholder="หมายเลขสมาชิก / เบอร์โทรศัพท์"
                @keypress="handlePushMessage"
                v-model="filter.search"
              ></b-form-input>
            </b-input-group>
            <b-button
              class="search-circle-bth"
              :style="$store.state.backgroundSecondary"
              ><span class="icon-input m-auto pr-2 text-white">
                <font-awesome-icon
                  icon="search"
                  title="View"
                  @click="searchUser"
                /> </span
            ></b-button>
          </div>
          <div>
            <div class="mt-3 p-2 detail-panel">
              <div class="d-flex justify-content-between">
                <p class="pt-3">ชื่อ</p>
                <InputText
                  textFloat=""
                  v-model="detail.first_name_th"
                  class="p-2 m-0 w-75"
                  placeholder="ชื่อ"
                  type="text"
                />
              </div>
              <div class="d-flex justify-content-between">
                <p class="pt-3">นามสกุล</p>
                <InputText
                  textFloat=""
                  v-model="detail.last_name_th"
                  class="p-2 m-0 w-75"
                  placeholder="นามสกุล"
                  type="text"
                />
              </div>
              <div class="d-flex justify-content-between">
                <p class="pt-3">โทร.</p>
                <InputText
                  textFloat=""
                  v-model="detail.telephone"
                  class="p-2 m-0 w-75"
                  placeholder="เบอร์โทรศัพท์"
                  type="text"
                />
              </div>
              <div class="d-flex justify-content-between">
                <p class="pt-3">สมาชิก</p>
                <InputText
                  textFloat=""
                  disabled
                  v-model="detail.member_id"
                  class="p-2 m-0 w-75"
                  placeholder="เบอร์โทรศัพท์"
                  type="text"
                />
              </div>
              <div class="d-flex justify-content-between">
                <p class="pt-3">คะแนนสะสม</p>
                <InputText
                  textFloat=""
                  disabled
                  v-model="detail.sumPoint"
                  class="p-2 m-0 w-75"
                  placeholder="เบอร์โทรศัพท์"
                  type="text"
                />
              </div>
              <div class="my-2 text-center">
                <b-button class="default-btn radius-btn w-75" @click="gotoReport"
                  ><span>รายการขายย้อนหลัง</span></b-button
                >
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="text-center">
          <div class="mb-4 w-100">
            <b-button
              class="radius-btn text-white w-75"
              :style="$store.state.backgroundSecondary"
              @click="submitForm"
              ><span>บันทึก</span></b-button
            >
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideCustomer",
  components: { OtherLoading, InputText },
  props: {
    search: {
      type: String,
      isRequired: true,
    },
    user: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      filter: {
        search: "",
      },
      detail: {
        user_guid: "",
        user_id: "",
        member_id: "",
        first_name_th: "",
        last_name_th: "",
        telephone: "",
        point: 0,
      },
      isLoading: false,
    };
  },
  methods: {
    show() {
      this.filter.search = this.search;
      this.getUserDetail();
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
    },
    getUserDetail() {
      this.isLoading = true;
      this.axios
        .get(
          `${this.$baseUrl}/customer/user_lookup_byid/${
            this.user.user_guid
          }/${this.$cookies.get("branch_id")}`
        )
        .then((data) => {
          if (data.result == 1) {
            this.detail = data.detail;
            this.detail.sumPoint = data.detail.center_point + data.detail.point;
          }
          this.isLoading = false;
        });
    },
    searchUser() {
      this.$emit("onChangehUser", this.filter.search, 'change');
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.searchUser();
      }
    },
    gotoReport() {
      this.$router.push(`/report?memberID=${this.user.member_id}`);
    },
    submitForm() {
      this.detail.firstname = this.detail.first_name_th;
      this.detail.lastname = this.detail.last_name_th;
      this.$emit("onChangeUserData", this.detail);
    },
  },
};
</script>

<style scoped></style>
